import React from 'react';

function FooterAdmin() {
  return (
    <footer className='mt-6 w-full flex overflow-hidden bg-white bg-gradient-radial-2 from-primary-100 '>
        <div className='w-full flex flex-col'>
            <span className='h-32 w-full text-slate-500'></span>
            <span className='h-6 w-full text-white text-center font-medium'>Laboratorio Santa Bárbara ©, Derechos Reservados</span>
        </div>
    </footer>
  )
}

export default FooterAdmin
